export const styles = (theme) => ({
  main: {
    "& a": {
      color: theme.palette.secondary.main,
    },
  },
  article: {
    ...theme.typography.body2,

    ...Array.from({ length: 6 }, (_, idx) => idx + 1).reduce(
      (acc, level, idx) => ({
        ...acc,
        [`& h${level}`]: { color: theme.typography[`h${level}`].color },
      }),
      {}
    ),

    "& p, & blockquote": {
      minWidth: `calc(50% - ${theme.spacing(2)})`,
    },

    "& img": {
      maxWidth: "100%",
      display: "block",
      margin: "0 auto",
    },

    "& blockquote": {
      display: "flex",
      margin: "1em 0",
      padding: "0.5em 0.5em 0.5em 1.5em",
      borderLeft: `calc(${theme.spacing(1)} / 2) solid ${
        theme.palette.text.primary
      }`,
      backgroundColor: " rgba(0, 0, 0, 0.1)",

      "& p": {
        fontStyle: "italic",

        "&::before": { content: "'« '" },
        "&::after": { content: "' »'" },
      },
    },

    "& ul": {
      display: "flex",
      flexDirection: "column",
    },

    // Figure
    "& figure": {
      margin: `0 auto ${theme.spacing(2)}`,

      "& figcaption": {
        textAlign: "center",
      },

      "& .audio": {
        textAlign: "center",
      },

      "& .video": {
        position: "relative",
        width: "100%",
        height: 0,
        paddingBottom: "calc(9 / 16 * 100%)",

        "& iframe": {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        },

        "& ~ figcaption": {
          marginTop: theme.spacing(1),
        },
      },

      "& > iframe": {
        width: "100%",
        height: "initial",
        aspectRatio: "16 / 9",
      },

      [theme.breakpoints.up("sm")]: { maxWidth: "80%" },

      [theme.breakpoints.up("md")]: {
        clear: "both",

        "&.left, &.right": {
          maxWidth: "50%",
          margin: theme.spacing(0, 0, 1, 0),
          padding: theme.spacing(0, 0, 1, 0),
        },

        "&.left": {
          float: "left",
          clear: "left",
          marginRight: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },

        "&.right": {
          float: "right",
          clear: "right",
          marginLeft: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        },
      },
    },

    "& table": {
      width: "100%",
      borderCollapse: "collapse",
      borderSpacing: 0,

      "& td": {
        border: `1px solid ${theme.palette.text.primary}`,
        padding: theme.spacing(1),
      },
    },

    "& hr": {
      margin: theme.spacing(2, 0),
      padding: 0,
      height: 1,
      width: "100%",
      border: "none",
      backgroundColor: theme.palette.text.primary,
    },

    "& > *:first-child": { marginTop: 0 },
    "& > *:last-child": { marginBottom: 0 },
  },
  artist: {
    "& .metrics": {
      display: "flex",
      flexDirection: "column",
      minWidth: `calc(50% - ${theme.spacing(1)})`,
      margin: `${theme.spacing(2)} auto`,
      clear: "none",

      "& .metric": {
        display: "flex",
        alignItems: "center",
        margin: theme.spacing(1, 0),

        "& > *:first-child, & > *:last-child": { flex: 1 },
        "& > *:first-child": { textAlign: "right" },
        "& > *:last-child": { textAlign: "left" },

        "& > *:nth-child(2)": {
          width: 100,
          height: "1.2em",
          border: "1px solid rgba(0, 0, 0, 0.2)",
          margin: theme.spacing(0, 2),
          padding: 1,
          display: "flex",

          "&::before": {
            content: "''",
            display: "block",
            backgroundColor: theme.palette.primary.main,
            width: 0,
          },

          ...Array.from({ length: 11 }).reduce(
            (acc, _, idx) => ({
              ...acc,
              [`&[data-level='${idx}']::before`]: { width: `${idx * 10}%` },
            }),
            {}
          ),

          [theme.breakpoints.up("sm")]: { width: 140 },
          [theme.breakpoints.up("md")]: { width: 160 },
        },
      },
    },
  },
});

export const theme = {
  typography: {
    fontFamily: ['"DINPro"', "sans-serif"],
    fontSize: 16,
    body1: { lineHeight: 1.2 },
    body2: { lineHeight: 1.2 },
    h1: { fontWeight: 700, fontSize: "2rem" },
    h2: { fontWeight: 700, fontSize: "1.5rem" },
    h3: { fontWeight: 700, fontSize: "1.17rem" },
    h4: { fontWeight: 700, fontSize: "1rem" },
    h5: { fontWeight: 700, fontSize: "0.83rem" },
    h6: { fontWeight: 700, fontSize: "0.67rem" },
  },
  palette: {
    text: {
      primary: "rgba(8, 55, 73, 0.87)",
      hint: "rgba(8, 55, 73, 0.38)",
      disabled: "rgba(8, 55, 73, 0.38)",
      secondary: "rgba(8, 55, 73, 0.54)",
    },
    primary: {
      main: "rgb(8, 55, 73)",
    },
    secondary: {
      main: "rgb(243, 135, 75)",
    },
  },
};
